import { render, staticRenderFns } from "./FieldValueList.vue?vue&type=template&id=98cf1dcc&"
import script from "./FieldValueList.vue?vue&type=script&lang=js&"
export * from "./FieldValueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports